import { render } from "./kubeovn.io.providernetwork.vue?vue&type=template&id=3bda3090&scoped=true"
import script from "./kubeovn.io.providernetwork.vue?vue&type=script&lang=js"
export * from "./kubeovn.io.providernetwork.vue?vue&type=script&lang=js"

import "./kubeovn.io.providernetwork.vue?vue&type=style&index=0&id=3bda3090&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bda3090"]])

export default __exports__